import { Route, Switch } from "react-router";
import CreateRecord from "./screens/CreateRecord";
import Landing from "./screens/Landing";
import NoMetamask from "./screens/NoMetamask";
import Record from "./screens/Record";
import Records from "./screens/Records";
import { web3 } from "./web3";

function App() {
  return (
    <Switch>
      <Route path="/" exact>
        <Landing />
      </Route>
      <Route path="/create-record" exact>
        <RequireMetamask>
          <CreateRecord />
        </RequireMetamask>
      </Route>
      <Route path="/records" exact>
        <RequireMetamask>
          <Records />
        </RequireMetamask>
      </Route>
      <Route path="/records/:recordAddress" exact>
        <RequireMetamask>
          <Record />
        </RequireMetamask>
      </Route>
    </Switch>
  );
}

export default App;

function RequireMetamask({ children }) {
  if (!web3) return <NoMetamask />;

  return children;
}
